import { ChangeDetectionStrategy, Component, Host } from '@angular/core';
import { BoschUiTableService } from '../bosch-ui-table.service';
import { BoschUiRowDefDirective } from '../directives/bosch-ui-row-def.directive';
import { map, takeWhile } from 'rxjs';

@Component({
  selector: 'bosch-ui-table-row',
  templateUrl: './bosch-ui-table-row.component.html',
  styleUrls: ['./bosch-ui-table-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BoschUiTableRowComponent<DataType> {
  public rowIndex = this.boschUiRowDefDirective.getRowIndex();
  public rowDisplayColumns = this.boschUiRowDefDirective.rowDisplayColumns;
  public rowData$ = this.boschUiRowDefDirective.rowsData$.pipe(
    takeWhile((rowsData: DataType[]) => rowsData.length > this.rowIndex),
    map((rowsData: DataType[]) => {
      const row = rowsData[this.rowIndex];
      this.boschUiRowDefDirective.incrementRowIndex();

      return row;
    }),
  );

  constructor(
    public tableService: BoschUiTableService<DataType>,
    @Host() public boschUiRowDefDirective: BoschUiRowDefDirective<DataType>,
  ) {}

  trackByFn(index: number): string {
    return `cell_${index}`;
  }
}
